const VALID_BILLING_INVOICE_GROUPS = new Set([
  'GM_WEBSITE',
  'GM_CONVERSATIONS',
  'GM_DIGAD',
  'GM_ALACARTE',
  'GM_ACCUTRADE',
]);

export const invoiceGroupOf = (row = {}) => String(
  row.invoiceGroup
    || row.invoice_group
    || row.accountMatch?.invoiceGroup
    || row.accountMatch?.evidence?.invoiceGroup
    || row.rawRow?.InvoiceGroup__c
    || row.raw_row?.InvoiceGroup__c
    || row.raw?.InvoiceGroup__c
    || ''
).trim();

export const invoiceGroupWarning = (row = {}) => {
  const invoiceGroup = invoiceGroupOf(row);
  if (!invoiceGroup) return null;
  const normalized = invoiceGroup.toUpperCase();
  if (VALID_BILLING_INVOICE_GROUPS.has(normalized)) return null;
  return {
    invoiceGroup,
    label: `Invoice group ${invoiceGroup} is outside GM Website, GM Conversations, GM DigAd, GM Alacarte, and GM Accutrade.`,
  };
};

export { VALID_BILLING_INVOICE_GROUPS };
